import { AMOUNTS } from 'constants/amounts';

import { formAddressToCustomerAdapter } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { LastWorkExperience, Numeric, Phone } from 'entities/creditForm/lib/formatters/base';

export class Job {
  constructor(
    private readonly data: Pick<
      Partial<TCreditFormCommonFields>,
      | 'employmentType'
      | 'unemploymentReason'
      | 'anotherUnemploymentReason'
      | 'monthlySalary'
      | 'areaOfEmployment'
      | 'employerType'
      | 'workAddress'
      | 'workOrganizationName'
      | 'workPhone'
      | 'jobTitle'
      | 'employerInn'
      | 'lastWorkExperienceStartMonth'
      | 'workLocationRoute'
      | 'okved'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  profile() {
    const lastWorkExperience = new LastWorkExperience(this.data.lastWorkExperienceStartMonth).map();

    return {
      employmentType: this.data.employmentType?.value || null,
      unemploymentReason: this.data.unemploymentReason?.value || null,
      anotherUnemploymentReason: this.data.anotherUnemploymentReason || null,
      monthlySalary:
        this.data.employmentType?.value === 'NotWorking'
          ? AMOUNTS.monthlySalaryMin
          : new Numeric(this.data.monthlySalary).format(),
      jobType: this.data.jobTitle?.data?.type || null,
      areaOfEmployment: this.data.areaOfEmployment?.value || null,
      ...(this.data.okved ? { okved: this.data.okved } : {}),
      employerType: this.data.employerType?.value || null,
      workAddress: formAddressToCustomerAdapter(this.data.workAddress, {
        locationRoute: this.data.workLocationRoute,
      }),
      workOrganizationName: this.data.workOrganizationName || null,
      workPhone: new Phone(this.data.workPhone).format(),
      jobTitle: this.data.jobTitle?.value || null,
      employerInn: this.data.employerInn || null,
      ...lastWorkExperience,
    };
  }

  loans() {
    const employmentType = this.data.employmentType?.value || null;

    const isNotWorking = employmentType === 'NotWorking';
    const isRetired = employmentType === 'Retired';
    const isBusinessOwner = employmentType === 'BusinessOwner';

    if (isNotWorking) {
      return {
        employmentType,
        unemploymentReason: this.data.unemploymentReason?.value || null,
        anotherUnemploymentReason: this.data.anotherUnemploymentReason || null,
        monthlySalary: AMOUNTS.monthlySalaryMin,
        seniority: undefined,
        jobType: null,
      };
    }

    if (isRetired) {
      return {
        employmentType,
        monthlySalary: new Numeric(this.data.monthlySalary).format(),
        seniority: undefined,
        jobType: null,
        unemploymentReason: null,
        anotherUnemploymentReason: null,
      };
    }

    const lastWorkExperience = new LastWorkExperience(this.data.lastWorkExperienceStartMonth).map();

    return {
      employmentType,
      monthlySalary: new Numeric(this.data.monthlySalary).format(),
      areaOfEmployment: this.data.areaOfEmployment?.value || null,
      ...(this.data.okved ? { okved: this.data.okved } : {}),
      employerType: this.data.employerType?.value || null,
      workAddress: formAddressToCustomerAdapter(this.data.workAddress, {
        locationRoute: this.data.workLocationRoute,
      }),
      workOrganizationName: this.data.workOrganizationName || null,
      workPhone: new Phone(this.data.workPhone).format(),
      employerInn: this.data.employerInn || null,
      unemploymentReason: null,
      anotherUnemploymentReason: null,
      ...lastWorkExperience,
      ...(!isBusinessOwner
        ? { jobType: this.data.jobTitle?.data?.type || null, jobTitle: this.data.jobTitle?.value || null }
        : { jobType: null, jobTitle: null }),
    };
  }
}
